/* src/app/shared/components/modal/modal.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
.app-modal.p-dialog {
  min-width: 640px;
  border-radius: 8px;
  overflow: hidden;
  border-color: transparent !important;
}
@media screen and (max-width: 1368px) {
  .app-modal.p-dialog {
    min-width: min(640px, 92vw);
  }
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog {
    min-width: 92vw;
  }
}
.app-modal.p-dialog .p-dialog-header {
  padding: 40px 40px 0;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog .p-dialog-header {
    padding: 20px 20px 0;
  }
}
.app-modal.p-dialog .p-dialog-content {
  padding: 40px 40px 24px;
  text-align: center;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog .p-dialog-content {
    padding: 24px 20px 16px;
  }
}
.app-modal.p-dialog .p-dialog-footer {
  padding: 0 40px 40px;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog .p-dialog-footer {
    padding: 0 20px 24px;
  }
}
.app-modal.p-dialog .p-dialog-footer > * {
  justify-content: center;
}
.app-modal.p-dialog .p-dialog-footer button {
  height: 40px;
}
.app-modal.p-dialog.modal-sm {
  min-width: min(400px, 92vw);
}
.app-modal.p-dialog.modal-lg {
  min-width: min(800px, 92vw);
}
.app-modal.p-dialog.modal-xl {
  min-width: min(960px, 92vw);
}
.app-modal.p-dialog h5.modal-title {
  font-size: 30px;
  line-height: 37px;
  font-weight: bold;
}
.app-modal.p-dialog .binge-inactivity {
  gap: 16px;
}
.app-modal.p-dialog.modal-terms {
  width: min(802px, 100%) !important;
  max-width: 802px;
  margin: 0 auto;
}
.app-modal.p-dialog.modal-terms .p-dialog-content {
  width: 100%;
  max-height: 85vh !important;
  overflow-y: auto;
  padding: 42px !important;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog.modal-terms .p-dialog-content {
    padding: 20px !important;
  }
}
.app-modal.p-dialog.modal-terms .p-dialog-content p.modal-body-data h3 {
  text-align: center !important;
  color: var(--text_primary) !important;
  font-size: 30px !important;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog.modal-terms .p-dialog-content p.modal-body-data h3 {
    font-size: 24px !important;
  }
}
.app-modal.p-dialog.modal-terms .p-dialog-content p.modal-body-data p {
  text-align: left !important;
  color: var(--text_secondary) !important;
  font-size: 16px !important;
}
@media screen and (max-width: 576px) {
  .app-modal.p-dialog.modal-terms .p-dialog-content p.modal-body-data p {
    font-size: 14px !important;
  }
}
.app-modal.p-dialog.modal-type-consent {
  border-radius: calc(var(--tile_border_radius) / 10 * var(--base-tile-radius));
  background: var(--background_tertiary);
}
.app-modal.p-dialog.modal-type-consent .p-dialog-content {
  background: var(--background_tertiary);
}
.app-modal.p-dialog.modal-type-consent .p-dialog-content .modal-body-data {
  text-align: left;
  color: var(--text_secondary);
}
.app-modal.p-dialog.modal-type-consent .p-dialog-content .modal-body-data ul,
.app-modal.p-dialog.modal-type-consent .p-dialog-content .modal-body-data ol {
  padding-left: 1.5em;
  margin: 8px 0;
}
/*# sourceMappingURL=modal.component.css.map */
